import React from 'react'
import cl from './CollectingStatistics.module.css'
import { Box, Button, Flex, Grid, Input, Table, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react'

function CollectingStatisticsCohorts() {
    return (
        <Grid gap='var(--default-gap)'>
            <Flex className={cl.container} marginRight='auto'>
                <Input
                    size='sm'
                    maxW='300px'
                    placeholder='ФИО куратора или ПМ'
                />
                <Button
                    size='sm'
                    minW='100px'
                >
                    Обновить
                </Button>
            </Flex>
            <Box className={cl.tableWrapper}>
                <Table className={cl.table}>
                    <Thead>
                        <Tr>
                            <Th></Th>
                            <Th colSpan={2}>Отписка (чел.)</Th>
                            <Th colSpan={2}>%</Th>
                            <Th colSpan={4}>Теги (предмет)</Th>
                        </Tr>
                        <Tr>
                            <Th>Когорта</Th>
                            <Th>План</Th>
                            <Th>Факт</Th>
                            <Th>Отписка</Th>
                            <Th>Сбор</Th>
                            <Th>Резерв</Th>
                            <Th>Ждет результатов</Th>
                            <Th>Предмет из цели</Th>
                            <Th>И тд</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        <Tr>
                            <Th>А1</Th>
                            <Td></Td>
                        </Tr>
                        <Tr>
                            <Th>А2</Th>
                            <Td></Td>
                        </Tr>
                        <Tr>
                            <Th>А3</Th>
                            <Td></Td>
                        </Tr>
                    </Tbody>
                </Table>
            </Box>
        </Grid>
    )
}

export default CollectingStatisticsCohorts
